export const LOGIN_RESPONSE = 'LOGIN_RESPONSE';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_AUTH = 'LOGIN_AUTH';
export const UPDATE_AUTH_USER = 'UPDATE_AUTH_USER';
export const CHANGE_STATUS_CODE = 'CHANGE_STATUS_CODE';
